import { MessageBar, MessageBarType, Spinner } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../../context';
import * as QueryAI from '../../AIQuestion/AIQuestionQuery';
import * as QueryAIAssistant from '../ContentUnderstandingQuery';
import EditContentUnderstanding from './EditContentUnderstanding';

export default class EditContentUnderstandingContainer extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { auth, apol, hidePanel } = this.props
        const id = this.props.aiAssistantId
        return (
            <div>
                {/*Edit AI Question*/}
                {id !== null && (
                    <Query
                        query={QueryAIAssistant.queryGetContentUnderstandingQuestion}
                        variables={{ auth, id }}>
                        {({ loading, error, data }) => {
                            if (loading) {
                                return (
                                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                )
                            }
                            if (error) {
                                return (
                                    <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={true}
                                        dismissButtonAriaLabel="Close"
                                    >
                                        {this.context.getTranslation("compliance", "error")}
                                    </MessageBar>
                                )
                            }
                            if (data.getAIQuestion == null) {
                                return (<MessageBar>
                                    {this.context.getTranslation("compliance", "noData")}
                                </MessageBar>)
                            }
                            return (<div>
                                <EditContentUnderstanding
                                    data={data.getAIQuestion}
                                    closePanel={hidePanel}
                                    apol={apol}
                                    auth={auth}
                                    userRules={this.props.userRules}
                                    theme={this.props.theme} 
                                    refreshAIAssistant={this.props.refreshAIAssistant}
                                    setMessageError={this.props.setMessageError}
                                />
                            </div>
                            )
                        }}
                    </Query>
                )
                }
                {/*Create question*/}
                {
                    id === null && (
                        <div>
                            <EditContentUnderstanding
                                closePanel={hidePanel}
                                apol={apol}
                                auth={auth}
                                userRules={this.props.userRules}
                                theme={this.props.theme} 
                                refreshAIAssistant={this.props.refreshAIAssistant}
                                setMessageError={this.props.setMessageError}
                            />
                        </div>
                    )
                }
            </div>
        );
    }
}
